import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IAgentModelState {
  agentModelDetail: IObjectState<any>
}

export const prefix = "agent-model/agent-model"

export const state = (): IAgentModelState => ({
  agentModelDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.agentModelDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: IAgentModelState, data) => {
    Vue.set(state, "agentModelDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.agentModelDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.agentModelDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.agentModelDetail,
          e.response?.data || e
        )
      )
    }
  },
}
